import { money } from "../../utilities/currency";

/** Deutsch (German) */
const de = {
  home: {
    offer: "✨ Sonderangebot – Zahle 99 kr, erhalte 198 kr Gesprächsguthaben! ✨",
    signIn: "Anmelden",
    join: "Mitmachen",
    allAdvisors: "Alle Berater",
    festivalTitle: "Festival-Kampagnen",
    referTitle: "Erhalte deine erste Beratung kostenlos!",
    referBody:
      "Buche ein 15-minütiges kostenloses Gespräch. Perfekt, um den richtigen Berater zu finden – sicher, digital und unverbindlich.",
    blogTitle: "Aus dem Mystic-Blog",
    viewAll: "Alle ansehen",
    subscribeLine: "Erhalte neue Ratgeber und Angebote per E-Mail.",
    read: "Lesen",
    invite: "Kostenlose Beratung buchen",
    sponsored: "Gesponsert",
    ad: (n) => `Anzeige ${n}`,
    adBlurb: "Bewirb hier Produkte, Apps oder Veranstaltungen.",
    learnMore: "Mehr erfahren",
    connectNow: "Jetzt verbinden",
    from: "ab",
    minutes: "Min",
    verified: "Verifiziert",
    categories: [
      "Liebes-Reading",
      "Hellsicht-Reading",
      "Tarot-Reading",
      "Astrologie & Horoskop",
      "Engelbotschaften",
      "Orakel-Beratung",
      "Traumdeutung",
      "Spirituelles Medium",
    ],
    hero: {
      name: "Die Berater",
      tag: "Liebesexperte",
      blurb:
        "Mein Versprechen: Ich bin für dich da. Wenn es schwer ist zu wissen, wem man vertrauen kann, ist echte Präsenz alles.",
      getReading: "Beratung buchen",
    },
    footer: {
      getApp: "Hol dir die App für Klarheit, wo immer du bist.",
      explore: "Entdecken",
      special: "Spezialgebiete",
      more: "Mehr",
      advisors: "Berater",
      blog: "Unser Blog",
      applyCode: "Aktionscode verwenden",
      support: "Kundensupport",
      about: "Über uns",
      apply: "Berater? Hier bewerben",
      privacy: "Datenschutz",
      terms: "AGB",
    },
    wallet: {
      title: "Gesprächsminuten kaufen",
      intro:
        "Die Minuten werden in deiner Mystic-Wallet gespeichert und können bei allen Beratern genutzt werden (Chat / Anruf / Video).",
      numLabel: "Die Telefonnummer, von der du anrufst",
      amount: "Betrag wählen",
      buy: (amt) => `${money(amt)} Guthaben kaufen`,
      learn: "Mehr über Zahlungsmethoden erfahren",
      err: "Gib eine gültige Telefonnummer ein",
      otp: (n) => `Code an ${n} gesendet. Gib ihn ein, um zu bestätigen.`,
      enterOtp: "Code eingeben",
      verify: "Bestätigen & Guthaben hinzufügen",
      cancel: "Abbrechen",
      success: (amt) => `${money(amt)} zu deiner Wallet hinzugefügt!`,
      pm1: "Vipps MobilePay",
      pm2: "Karte (erfordert Registrierung mit deiner Mobilnummer)",
      nolgin: "Keine Anmeldung für Vipps MobilePay nötig – direkt anrufen.",
    },
  },

  header: {
    hello: "Hallo",
    logout: "Abmelden",
    login: "Anmelden",
  },

  footer: {
    categories: [
      "Dummy 1",
      "Dummy 2",
      "Dummy 3",
      "Dummy 4",
      "Dummy 5",
      "Dummy 6",
      "Dummy 7",
      "Dummy 8",
    ],
    paymentMethods: "Zahlungsmethoden",
    footer: {
      getApp: "Hol dir die App für Klarheit, wo immer du bist.",
      explore: "Entdecken",
      special: "Spezialgebiete",
      more: "Mehr",
      advisors: "Berater",
      blog: "Unser Blog",
      applyCode: "Aktionscode verwenden",
      support: "Kundensupport",
      about: "Über uns",
      apply: "Berater? Hier bewerben",
      privacy: "Datenschutz",
      terms: "AGB",
    },
  },
};

export default de;
